export default __webpack_public_path__ + "img/apple-touch-icon.1e495487.png";